import React from 'react';
import styled, { css } from 'styled-components';
import Button from './Button';
export var SecondaryButtonIconTypes;
(function (SecondaryButtonIconTypes) {
    SecondaryButtonIconTypes["NONE"] = "NONE";
    SecondaryButtonIconTypes["ADD"] = "ADD";
})(SecondaryButtonIconTypes || (SecondaryButtonIconTypes = {}));
const IconAdd = require('../assets/images/glyphs/add_sec.svg');
const SecondaryButton = ({ imgSrc, iconType = SecondaryButtonIconTypes.NONE, ...rest }) => {
    if (typeof (imgSrc) === 'undefined') {
        if (iconType === SecondaryButtonIconTypes.ADD) {
            imgSrc = IconAdd;
        }
    }
    return React.createElement(StyledButton, { imgSrc: imgSrc, ...rest });
};
const StyledButton = styled(Button) `
  background: ${props => props.theme.colors.white};
  
  color: ${props => props.theme.colors.secondaryText};
  
  border-radius: 4px;
  border: 1px solid rgba(11,160,241,0.30);
  
  ${props => !props.isLoading && ActiveBehaviour}
`;
const ActiveBehaviour = css `

  :hover {
    border: 1px solid rgba(11,160,241,0.50);
  }
  
  :active {
    background: rgba(11,160,241,0.05);
    border: 1px solid rgba(11,160,241,0.40);
  }
`;
export default SecondaryButton;
//# sourceMappingURL=SecondaryButton.js.map